import logger from "../../utils/logger";


// Combine into HH:MM:SS format
export const  getCurrentTime = () => {
    const now = new Date();

    // Extract hours, minutes, and seconds
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');
    return `${hours}:${minutes}:${seconds}`;
}

export const getCurrentDate = (format = 'YYYY-MM-DD') => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');

    switch (format) {
        case 'DD/MM/YYYY':
            return `${day}/${month}/${year}`;
        case 'DD-MM-YYYY':
            return `${day}-${month}-${year}`;
        default: // 'YYYY-MM-DD'
            return `${year}-${month}-${day}`;
    }
}

export const formatDateToView = (inputDate) => {
    // Check if the input is a valid date
    const date = new Date(inputDate);
    // Ensure that the date is valid
    if (isNaN(date)) {
        logger.error('Invalid date format');
        return null;
    }

    // Extract day, month, and year
    const day = String(date.getDate()).padStart(2, '0');  // Ensure 2-digit day
    const month = String(date.getMonth() + 1).padStart(2, '0');  // Ensure 2-digit month (getMonth() is 0-based)
    const year = date.getFullYear();

    // Return the formatted date as dd-mm-yyyy
    return `${day}-${month}-${year}`;
}

export const daysBetween = (dateString) => {
    const inputDate = new Date(dateString); // Convert input to a Date object
    const currentDate = new Date(); // Get the current date
    
    // Calculate the difference in time (milliseconds)
    const differenceInTime = inputDate - currentDate;
    
    // Convert the difference to days
    const differenceInDays = Math.ceil(differenceInTime / (1000 * 60 * 60 * 24)); // Round up to account for partial days
    
    return differenceInDays;
}

// Example usage
//logger.log(daysBetween('2024-12-01')); Example: -7 (if today is 2024-12-08)
//logger.log(daysBetween('2024-12-15')); Example: 7 (if today is 2024-12-08)
//logger.log(daysBetween('2024-12-08')); Example: 0 (if today is 2024-12-08)

export const getMonthRange = (year, month) => {
    const startDate = `${year}-${String(month).padStart(2, '0')}-01`;
    const endDate = new Date(year, month, 0).toISOString().split('T')[0]; // Last day of the month
    return { startDate, endDate };
};

// Example usage:
// const { startDate, endDate } = getMonthRange(2024, 12); 
// logger.log(startDate); // "2024-12-01"
// logger.log(endDate);   // "2024-12-31"

